import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=b27482e4&scoped=true"
import script from "./TemplateSetting.vue?vue&type=script&lang=js"
export * from "./TemplateSetting.vue?vue&type=script&lang=js"
import style0 from "./TemplateSetting.vue?vue&type=style&index=0&id=b27482e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27482e4",
  null
  
)

export default component.exports